import { TRANSLATION_LANGUAGES } from '../challenges/enums/translation-language';

export const TRANSLATED_LANGUAGE_SET = new Set<string>(TRANSLATION_LANGUAGES);
